<template>
  <div class="chattextareabox-box" ref="chatTextareaBox" @click="onClickBox">
    <textarea
      :placeholder="placeholder"
      rows="1"
      class="chattextareabox-textarea"
      ref="textArea"
      wrap="hard"
      :disabled="disabled"
      @input="inputEvent"
      @compositionstart="isComposing = true"
      @compositionend="handleCompositionEnd"
      @keydown="handlerEnter"
      @blur="blurEvent"
    ></textarea>

    <!-- Icon -->
    <a tabindex="0" class="send-iconwrap cursor">
      <img
        v-if="!disabled"
        class="send-icon"
        @click="onClickSendIcon"
        src="/media/images/icon/send_abled_icon.png"
        alt="send_abled_icon"
      />
      <img v-else class="send-icon" src="/media/images/icon/send_abled_icon.png" alt="send_abled_icon" />
    </a>
  </div>
</template>
<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: '',
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    maxlength: {
      type: Number,
      default: 9999,
      required: false
    }
  },
  emits: ['change-textarea', 'change-height', 'click-sendicon', 'enter-event'],
  data() {
    return {
      isComposing: false,
      textAreaContents: ''
    };
  },
  methods: {
    focus() {
      this.$refs.textArea.dispatchEvent(new Event('input'));
    },
    clearTextArea() {
      this.textAreaContents = '';
      this.$refs.textArea.value = '';
      this.$refs.textArea.style.height = 'auto';
    },
    handlerEnter(event) {
      if (event.key === 'Enter') {
        if (event.shiftKey) {
          // 줄바꿈 허용 (기본 동작 유지)
        } else {
          event.preventDefault();
          if (!this.isComposing) {
            this.$emit('enter-event', this.textAreaContents);

            this.clearTextArea();
          }
        }
      }
    },
    blurEvent() {
      this.$refs.chatTextareaBox.classList.remove('active');
    },
    /**
     * @description textArea 높이 조정
     */
    setAutoHeight() {
      const el = this.$refs.textArea;
      el.style.height = 'auto';
      const max = 180;
      const height = el.scrollHeight;
      el.style.height = Math.min(height, max) + 'px';
      this.$emit('change-height', this.$refs.chatTextareaBox.clientHeight);
    },
    /**
     * @description Input Event
     */
    async inputEvent(e) {
      if (e.target) {
        e.target.value = e.target.value.slice(0, this.maxlength);
        this.textAreaContents = e.target.value;
        this.$emit('change-textarea', this.textAreaContents);
        await this.$nextTick();
        this.setAutoHeight();
      }
    },
    onClickBox() {
      if (this.disabled) return;
      this.$refs.textArea.focus();
      this.$refs.chatTextareaBox.classList.add('active');
    },
    handleCompositionEnd() {
      this.isComposing = false;
    },
    onClickSendIcon() {
      this.$emit('click-sendicon', this.textAreaContents);
      this.clearTextArea();
    }
  }
};
</script>
<style scoped src="@/assets/css/chattextareabox/chattextareabox.css"></style>
